export default __webpack_public_path__ + "static/media/4-10_icon.73cf2196.svg";